import { appSettings } from 'app/appSettings';
import { placeToConverter } from 'app/core/store/orders/orders.reducer';
import { util } from '../../util/util';
import { Florder, FlowLineItem } from '../../interfaces/florder.interface';
import { initialStateFlordersFilter } from '../../interfaces/florders-filter.model';
import { Florders } from '../../interfaces/florders.interface';
import { initialState } from '../../interfaces/florders.model';
import { emptyPlace } from '../../interfaces/place.model';
import * as actions from './flows.actions';
import * as customerActions from 'app/core/store/session/selected-customer/select-customer.actions';

function clearFilter(state: Florders): Florders {
  return {
    ...initialState,
    filterValues: state.filterValues,
  };
}

function load(state: Florders, action: actions.FlowsLoadAction): Florders {
  return {
    ...state,
    items: [],
    loading: true,
    filter: {
      ...state.filter,
      ...((action.payload && action.payload.filter) || state.filter),
    },
  };
}

/**
 *
 ExecuteHandshake?
 TRUE ->
 handshakeDate = null ?
 TRUE ->
 originalQuantity = 0 ?
 TRUE -> edit sender quantities, show ACCEPT button
 FALSE -> edit receiver quantities, show ACCEPT button
 FALSE -> show ACCEPT button, show definitive amount as original amount, no edit possible, quantity in the message equals already registered handshake amount
 FALSE ->
 status = 02 ?
 TRUE -> show CANCEL button
 FALSE -> no edit, no buttons
 * @param state
 * @param action
 */
function loadSuccess(state: Florders, action: actions.FlowsLoadSuccessAction): Florders {
  const definitions = action.payload.definitions;
  const places = action.payload.places;
  const flows = action.payload.flows;
  const multipleCustomers = action.payload.filterOnMultipleCustomers;

  const items = flows.items.map(flow => {
    let globalType = null;
    if (flow.executeHandshake) {
      globalType =
        flow.flowLineItems.length > 0 &&
        definitions.global.type.find(
          gt => gt.id === (util.isNumeric('' + flow.flowLineItems[0].originalQuantity) && '' + flow.flowLineItems[0].originalQuantity !== '0' ? 'IN' : 'OUT')
        );
    }

    let editOriginalQuantity = false;
    let editDefinitiveQuantity = false;
    let canCancel = false;
    let canAcceptHandshake = false;
    let canConfirmRegistration = false;
    let cannotEdit = false;
    let isHandshaker = false;
    let isRegistrar = false;

    // Sort flowLineItems
    const flowLineItems = [...flow.flowLineItems];
    if (flowLineItems && flowLineItems.length > 1) {
      flowLineItems.sort((a, b) => a.itemNumber - b.itemNumber);
    }
    if (!multipleCustomers) {
      switch (flow.handshakeStatus) {
        case appSettings.FLOW_STATUS_WAITING_FOR_HANDSHAKE:
          if (flow.executeHandshake) {
            canAcceptHandshake = true;
            isHandshaker = true;
            const firstLine: FlowLineItem = flowLineItems && flowLineItems.length && flowLineItems[0];
            if (firstLine && !flow.handshakeDate) {
              // can edit the values
              if (util.isNumeric('' + firstLine.originalQuantity) && '' + firstLine.originalQuantity !== '0') {
                editDefinitiveQuantity = true;
              } else {
                editOriginalQuantity = true;
              }
            } else {
              cannotEdit = true;
            }
          } else {
            isRegistrar = true;
            canCancel = true;
          }
          break;
        case appSettings.FLOW_STATUS_WAITING_FOR_SUPPLIER_REGISTRATION:
          if (flow.executeHandshake) {
            // this means it's the supplier and he can confirm (and the registrar)
            isRegistrar = true;
            cannotEdit = true;
            canConfirmRegistration = true;
          } else {
            // is receiver, did create the flow
            isHandshaker = true;
            canCancel = true;
          }
          break;
      }
    }
    return {
      ...flow,
      globalType,
      editOriginalQuantity,
      editDefinitiveQuantity,
      canCancel,
      canAcceptHandshake,
      canConfirmRegistration,
      isHandshaker,
      isRegistrar,
      shipmentNumbers: flow.shipmentNumber,
      from:
        places[flow.from.id] ||
        Object.assign({}, emptyPlace, {
          id: flow.from.id,
          name: flow.from.name,
        }),
      to:
        places[flow.to.id] ||
        Object.assign({}, emptyPlace, {
          id: flow.to.id,
          name: flow.to.name,
        }),
      // shippingCondition: flow.transport && definitions.transport.type.find(t => t.id === flow.transport) || { id: flow.transport as string, name: flow.transport as string },
      shippingCondition: null,
      status: flow.handshakeStatus && definitions.flow.status.find(st => st.id === flow.handshakeStatus),
      ccr: null,
      wholesaler: flow.wholeSalerId && definitions.flow.wholesaler.find(st => st.id === flow.wholeSalerId),
      flowLineItems: flowLineItems.map(fli => {
        let originalQuantity = (cannotEdit && flow.executeHandshake) || editOriginalQuantity ? fli.definitiveQuantity : fli.originalQuantity;
        let definitiveQuantity = editDefinitiveQuantity ? fli.originalQuantity : fli.definitiveQuantity;
        let differenceQuantity = fli.differenceQuantity;
        if (flow.handshakeStatus === appSettings.FLOW_STATUS_WAITING_FOR_SUPPLIER_REGISTRATION) {
          // TODO this needs cleanup and proper unit testing !!! Unfortunately, I'm currently not on the project anymore and doing changes after office hours...
          if (flow.executeHandshake) {
            originalQuantity = fli.originalQuantity; // is the sender => original is correct
            definitiveQuantity = null;
            if (flow.handshakeStatus === appSettings.FLOW_STATUS_WAITING_FOR_SUPPLIER_REGISTRATION) {
              originalQuantity = null;
              definitiveQuantity = fli.definitiveQuantity;
            }
          } else {
            originalQuantity = null; // is the receiver => definitive is correct
          }
          differenceQuantity = null;
        }
        return {
          ...fli,
          originalQuantity,
          definitiveQuantity,
          differenceQuantity,
        };
      }),
    } as Florder;
  });

  return {
    filterValues: state.filterValues,
    loaded: true,
    loading: false,
    downloading: false,
    items: items.map(item => {
      return {
        ...item,
      };
    }),
    filter: state.filter,
    totalItems: flows.totalItems,
    handshaking: false,
    handshaked: false,
  };
}

function loadFail(state: Florders): Florders {
  return {
    filterValues: state.filterValues,
    loaded: false,
    loading: false,
    downloading: false,
    items: [],
    totalItems: null,
    filter: state.filter,
    handshaking: false,
    handshaked: false,
  };
}

function download(state: Florders, action: actions.FlowsDownloadAction): Florders {
  return Object.assign({}, state, { downloading: true });
}

function downloadSuccess(state: Florders, action: actions.FlowsDownloadSuccessAction): Florders {
  return Object.assign({}, state, { downloading: false });
}

function downloadFail(state: Florders, action: actions.FlowsDownloadFailAction): Florders {
  return Object.assign({}, state, { downloading: false });
}

function setFilter(state: Florders, action: actions.FlowsSetFilterAction): Florders {
  return Object.assign({}, state, {
    filter: {
      ...initialStateFlordersFilter,
      ...action.payload.filter,
    },
  });
}

function acceptFlowStart(state: Florders, action: actions.FlowsAcceptFlowStartAction): Florders {
  return Object.assign({}, state, {
    handshaking: true,
    handshaked: null,
  });
}

function acceptFlowSuccess(state: Florders, action: actions.FlowsAcceptFlowSuccessAction): Florders {
  return Object.assign({}, state, {
    handshaking: false,
    handshaked: true,
    items: state.items.map(item => {
      if (item.etmOrderNumber === action.payload.etmOrderNumber) {
        return {
          ...item,
          status: action.payload.status,
        };
      } else {
        return item;
      }
    }),
  });
}

function acceptFlowFail(state: Florders, action: actions.FlowsAcceptFlowFailAction): Florders {
  return Object.assign({}, state, {
    handshaking: false,
    handshaked: false,
  });
}

function acceptFlowFromBatchStart(state: Florders, action: actions.FlowsAcceptFlowFromBatchStartAction): Florders {
  return Object.assign({}, state, {
    items: state.items.map(flow => {
      if (flow.etmOrderNumber === action.payload.flow.etmOrderNumber) {
        return {
          ...flow,
          blacklisted: true,
        };
      } else {
        return flow;
      }
    }),
  });
}

function acceptFlowFromBatchSuccess(state: Florders, action: actions.FlowsAcceptFlowFromBatchSuccessAction): Florders {
  return Object.assign({}, state, {
    items: state.items.map(flow => {
      if (flow.etmOrderNumber === action.payload.flow.etmOrderNumber) {
        return {
          ...flow,
          status: action.payload.status,
          blacklisted: false,
          failed: false,
          failMessage: null,
          executeHandshake: false,
        };
      } else {
        return flow;
      }
    }),
  });
}

function acceptFlowFromBatchFail(state: Florders, action: actions.FlowsAcceptFlowFromBatchFailAction): Florders {
  return {
    ...state,
    items: state.items.map(flow => {
      if (flow.etmOrderNumber === action.payload.flow.etmOrderNumber) {
        return {
          ...flow,
          failed: true,
          failMessage: util.getInstantErrorMessage(action.payload),
          blacklisted: false,
        };
      } else {
        return flow;
      }
    })
  };
}

function cancelFlowStart(state: Florders, action: actions.FlowsCancelFlowStartAction): Florders {
  return Object.assign({}, state, {
    handshaking: true,
    handshaked: null,
  });
}

function cancelFlowSuccess(state: Florders, action: actions.FlowsCancelFlowSuccessAction): Florders {
  return Object.assign({}, state, {
    handshaking: false,
    handshaked: true,
    items: state.items.map(item => {
      if (item.etmOrderNumber === action.payload.etmOrderNumber) {
        return {
          ...item,
          status: action.payload.status,
        };
      } else {
        return item;
      }
    }),
  });
}

function cancelFlowFail(state: Florders, action: actions.FlowsCancelFlowFailAction): Florders {
  return Object.assign({}, state, {
    handshaking: false,
    handshaked: false,
  });
}

function filterValuesReset(state: Florders, action: actions.FlowsFilterValuesResetAction): Florders {
  return {
    ...state,
    filterValues: {
      ...initialState.filterValues,
    },
  };
}

function filterValuesLoad(state: Florders, action: actions.FlowsFilterValuesLoadAction): Florders {
  return {
    ...state,
    filterValues: {
      ...initialState.filterValues,
      loading: true,
      customerIds: action.payload.customerIds,
    },
  };
}

function filterValuesLoadSuccess(state: Florders, action: actions.FlowsFilterValuesLoadSuccessAction): Florders {
  const idToDefinition = array => id =>
    array.find(t => t.id === id) || {
      id,
      name: id,
    };
  const filterValues = action.payload.filterValues;
  const definitions = action.payload.definitions;
  const nameComparator = (a, b) => (a && b && a.name.localeCompare(b.name)) || (a && !b && -1) || (!a && b && 1) || 0;
  return {
    ...state,
    filterValues: {
      ...state.filterValues,
      loading: false,
      loaded: true,
      shippingConditions: filterValues.shippingCondition.map(idToDefinition(definitions.transport.type)).sort(nameComparator),
      froms: filterValues.from.map(id => filterValues.locations.find(l => l.id === id)).sort(nameComparator),
      tos: filterValues.to.map(id => filterValues.locations.find(l => l.id === id)).sort(nameComparator),
      // locations: filterValues.locations.map(placeToConverter).filter((o, i) => filterValuesLoadedCounter > 1 || i % 3 != 0),
      locations: filterValues.locations.map(placeToConverter),
      orderTypes: filterValues.orderType.map(idToDefinition(definitions.flow.type)).sort(nameComparator),
      incoterms: [],
      pallets: filterValues.palletId.map(idToDefinition(definitions.pallet.type)).sort(nameComparator),
      packings: filterValues.packingId.map(idToDefinition(definitions.packing.type)).sort(nameComparator),
      wholesalers: (filterValues.wholeSalerId && filterValues.wholeSalerId.map(idToDefinition(definitions.flow.wholesaler)).sort(nameComparator)) || [],
    },
  };
}

function filterValuesLoadFail(state: Florders, action: actions.FlowsFilterValuesLoadFailAction): Florders {
  return {
    ...state,
    filterValues: {
      ...state.filterValues,
      loading: false,
      failed: true,
    },
  };
}

function maxAmountPopupShown(state: Florders, action: actions.FlowsMaxAmountPopupShownAction): Florders {
  return {
    ...state,
    maxAmountDialogShown: true,
  };
}

function maxAmountPopupReset(state: Florders, action: actions.FlowsMaxAmountPopupResetAction): Florders {
  return {
    ...state,
    maxAmountDialogShown: false,
  };
}

export function reducer(state = initialState, action: actions.Actions | customerActions.Actions): Florders {
  let newState = state;
  switch (action.type) {
    case customerActions.SET_SELECTED_CUSTOMER:
    case actions.FLOWS_CLEAR_FILTER: {
      newState = clearFilter(state);
      break;
    }
    case actions.FLOWS_LOAD: {
      newState = load(state, action);
      break;
    }
    case actions.FLOWS_LOAD_SUCCESS: {
      newState = loadSuccess(state, action);
      break;
    }
    case actions.FLOWS_LOAD_FAIL: {
      newState = loadFail(state);
      break;
    }
    case actions.FLOWS_DOWNLOAD: {
      newState = download(state, action);
      break;
    }
    case actions.FLOWS_DOWNLOAD_SUCCESS: {
      newState = downloadSuccess(state, action);
      break;
    }
    case actions.FLOWS_DOWNLOAD_FAIL: {
      newState = downloadFail(state, action);
      break;
    }
    case actions.FLOWS_SET_FILTER: {
      newState = setFilter(state, action);
      break;
    }
    case actions.FLOWS_ACCEPT_FLOW_START: {
      newState = acceptFlowStart(state, action);
      break;
    }
    case actions.FLOWS_ACCEPT_FLOW_SUCCESS: {
      newState = acceptFlowSuccess(state, action);
      break;
    }
    case actions.FLOWS_ACCEPT_FLOW_FAIL: {
      newState = acceptFlowFail(state, action);
      break;
    }
    case actions.FLOWS_ACCEPT_FLOW_FROM_BATCH_START: {
      newState = acceptFlowFromBatchStart(state, action);
      break;
    }
    case actions.FLOWS_ACCEPT_FLOW_FROM_BATCH_SUCCESS: {
      newState = acceptFlowFromBatchSuccess(state, action);
      break;
    }
    case actions.FLOWS_ACCEPT_FLOW_FROM_BATCH_FAIL: {
      newState = acceptFlowFromBatchFail(state, action);
      break;
    }
    case actions.FLOWS_CANCEL_FLOW_START: {
      newState = cancelFlowStart(state, action);
      break;
    }
    case actions.FLOWS_CANCEL_FLOW_SUCCESS: {
      newState = cancelFlowSuccess(state, action);
      break;
    }
    case actions.FLOWS_CANCEL_FLOW_FAIL: {
      newState = cancelFlowFail(state, action);
      break;
    }
    case actions.FLOWS_FILTER_VALUES_RESET: {
      newState = filterValuesReset(state, action);
      break;
    }
    case actions.FLOWS_FILTER_VALUES_LOAD: {
      newState = filterValuesLoad(state, action);
      break;
    }
    case actions.FLOWS_FILTER_VALUES_LOAD_SUCCESS: {
      newState = filterValuesLoadSuccess(state, action);
      break;
    }
    case actions.FLOWS_FILTER_VALUES_LOAD_FAIL: {
      newState = filterValuesLoadFail(state, action);
      break;
    }
    case actions.FLOWS_MAX_AMOUNT_POPUP_SHOWN: {
      newState = maxAmountPopupShown(state, action);
      break;
    }
    case actions.FLOWS_MAX_AMOUNT_POPUP_RESET: {
      newState = maxAmountPopupReset(state, action);
      break;
    }
  }
  return newState;
}
